/**
 * 七牛裁剪
 imageView2/<mode>
 /w/<LongEdge>
 /h/<ShortEdge>
 /format/<Format>
 /interlace/<Interlace>
 /q/<Quality>
 /ignore-error/<ignoreError>
 */
// console.log(IMG_DEFAULT)
export function thumbnail(src, w = 90, h = 60, defaultImg = 'http://img.tutubox.cn/gemDefult-2.png', option = {}) {
    if (!src) return defaultImg || '';
  
    let options = {
      mode: 1,
      w,
      h,
      interlace: 1,
      'ignore-error': 1,
      ...option // 这里没对参数进行限制，使用时应该遵循七牛的接口
    };
  
    let mode = options.mode;
    delete options.mode;
  
    if (!w) delete options.w;
    if (!h) delete options.h;
  
    let optionString = Object.keys(options).reduce((str, key) => {
      return str + '/' + key + '/' + options[key];
    }, '');
  
  
    return `${src}?imageView2/${mode}` + optionString;
}
  
export function thumbnailGem(src, w = 60, h = 60, defaultImg = 'http://img.tutubox.cn/gemDefultGem.png', option = {}) {
    if (!src) return defaultImg || '';
  
    let options = {
      mode: 1,
      w,
      h,
      interlace: 1,
      'ignore-error': 1,
      ...option // 这里没对参数进行限制，使用时应该遵循七牛的接口
    };
  
    let mode = options.mode;
    delete options.mode;
  
    if (!w) delete options.w;
    if (!h) delete options.h;
  
    let optionString = Object.keys(options).reduce((str, key) => {
      return str + '/' + key + '/' + options[key];
    }, '');
  
  
    return `${src}?imageView2/${mode}` + optionString;
}